module.exports = __webpack_public_path__ + "static/media/flrPlan.55578470.png";